import React from "react";

const Biographie = () => {
  return (
    <div className="biographie">
      <h2>En recherche d’une nouvelle opportunité…</h2>
      <p>
        je suis développeur fullstack, spécialisé dans le frontend, j'ai une
        passion pour les nouvelles technologies et leurs facultés à améliorer la
        productivité des entreprises.
      </p>
      <p>
        <a href="#parcours">Mon parcours</a>, complété par ma passion pour
        internet et l'informatique, m'a permis d'acquérir les connaissances
        techniques et pratiques indispensables à l'exercice de ce métier.
        Maîtrisant différents <a href="#langages">languages informatiques</a> je
        peux m'adapter à tout type de projet.
      </p>
      <p>
        Je suis actuellement diplomé d'un bac+2 en developpement web chez
        openclassrooms. et j'ai été admis en troisième année dans la formation
        Responsable de projet web et mobile chez ETNA (Ecole des technologies
        numériques avancées). Actuellement je suis à la recherche d’un contrat
        d’apprentissage pour la rentrée 2022.
      </p>
      <p>
        J’ai choisi l’alternance pour être en réel contact avec le monde du
        travail ce qui me permettra d’acquérir de l’expérience professionnelle
        au cours de ma formation et de m’investir totalement dans de véritables
        projets en y mettant toute mon envie d’apprendre et toute mon énergie.
      </p>
    </div>
  );
};

export default Biographie;
